import React, { useRef } from 'react'
import styled from '@emotion/styled'
// import { css, jsx } from '@emotion/react'
import countries from 'i18n-iso-countries'
import { withTranslation } from 'react-i18next'
import splitTitleBody from '../../helpers/splitTitleBody'
import Table from './Table'

const Wrapper = styled.div`
  //position: absolute;
  top: 6cm;
  left: 0;
  right: 0;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  //background: red;
  padding-left: inherit;
  padding-right: inherit;
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  ${(props) =>
    props.left &&
    `
    align-items: flex-start;
    text-align: left;
  `} ${(props) =>
    props.right &&
    `
      // text-align: right;
      align-items: flex-end;
  `};
`

// Component
function Main(props) {
  const { invoice, customer, invoiceSettings, t, formatDate } = props
  const { body: descriptionBody, title: descriptionTitle } = splitTitleBody(
    invoice.description || ''
  )

  const invoiceInformationRef = useRef()
  // React.useLayoutEffect(() => {
  //   const boundingBox = invoiceInformationRef.current.getBoundingClientRect()
  //   console.log(
  //     'invoiceInformationBoundingBox',
  //     boundingBox.y + boundingBox.height
  //   )
  // })

  const hasReverseChargedLine = (invoice.Lines || []).some(
    (line) => line.vatCodeId === 'V-NL-V'
  )

  return (
   <div className='container-table-wrapper'>
     <table className='container-table'>
      <thead>
        <tr>
          <th>
            <div className='empty-header'></div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div className='content'>
              <Wrapper>
                {customer && (
                  <div className='customer addressee'>
                    <p className='label customer-name'>{customer.name}</p>
                    <p>
                      <React.Fragment>
                        {customer.contactName && (
                          <React.Fragment>
                            {customer.contactName}
                            <br />
                          </React.Fragment>
                        )}
                        {customer.address && (
                          <React.Fragment>
                            {customer.address.line1}
                            <br />
                            {customer.address.line2 &&
                              customer.address.line2 + '\n'}
                            {customer.address.postalCode}{' '}
                            {customer.address.city}
                            <br />
                            {(customer.address.country !== 'NL' ||
                              hasReverseChargedLine) && (
                              <React.Fragment>
                                {countries.getName(
                                  customer.address.country,
                                  invoiceSettings.language
                                )}
                                {/* TODO full name country instead of country code */}
                                <br />
                                {customer.vatIdentificationNumber} <br />
                              </React.Fragment>
                            )}
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    </p>
                  </div>
                )}
                <div
                  ref={invoiceInformationRef}
                  className='invoice-information'
                >
                  <h1 className='title invoice-number'>
                    {invoice.isCreditInvoice
                      ? t('creditInvoice')
                      : t('invoice')}{' '}
                    {invoice.invoiceNumber}
                  </h1>
                  <div className='invoice-information-content'>
                    <div
                      className={`invoice-details ${invoiceSettings.invoiceInformationLayout}`}
                    >
                      {invoiceSettings.invoiceInformationLayout ===
                      'vertical' ? (
                        <table className='invoice-details-content'>
                          <tbody>
                            <tr className='invoiceDate'>
                              <td className='label'>{t('invoiceDate')}</td>
                              <td className='value'>
                                {formatDate(invoice.invoiceDate)}
                              </td>
                            </tr>
                            <tr className='dueDate'>
                              <td className='label'>{t('dueDate')}</td>
                              <td className='value'>
                                {formatDate(invoice.dueDate)}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      ) : (
                        <div className='invoice-details-content'>
                          <div className='invoiceDate'>
                            <div className='label'>{t('invoiceDate')}</div>
                            <div className='value'>
                              {formatDate(invoice.invoiceDate)}
                            </div>
                          </div>
                          <div className='dueDate'>
                            <div className='label'>{t('dueDate')}</div>
                            <div className='value'>
                              {formatDate(invoice.dueDate)}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    {descriptionBody && (
                      <div className='description'>
                        {descriptionTitle && (
                          <p className='label'>{descriptionTitle}</p>
                        )}
                        <p>{descriptionBody}</p>
                      </div>
                    )}
                  </div>
                </div>
                <Table {...props} />
              </Wrapper>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td>
            <div className='empty-footer'></div>
          </td>
        </tr>
      </tfoot>
    </table>
   </div>
  )
}
export default withTranslation()(Main)
